import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";
import { Counter } from "@/components/Counter";

export const Market = () => {
  const { t } = useLang();
  const m = t.market;
  return (
    <section className="py-20 md:py-28 bg-ink text-white" data-testid="market-section">
      <div className="mx-auto max-w-[1280px] px-5 md:px-8">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <Reveal>
            <span className="eyebrow">— {m.label}</span>
            <p className="mt-5 font-display font-semibold text-2xl md:text-3xl text-white/80 leading-snug">
              {m.pre}{" "}
              <span className="font-display font-extrabold text-tricolor-green text-6xl md:text-8xl align-middle block md:inline mt-2 md:mt-0">
                {m.big}
              </span>{" "}
              {m.post}
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="text-base md:text-lg text-white/60 leading-relaxed">{m.body}</p>
            <div className="mt-8 flex gap-8">
              <div>
                <Counter to={220000} suffix="+" className="font-display font-extrabold text-3xl md:text-4xl text-white" />
                <div className="text-xs text-white/50 mt-1">Celiaci in Italia</div>
              </div>
              <div>
                <Counter to={6} suffix="M" className="font-display font-extrabold text-3xl md:text-4xl text-white" />
                <div className="text-xs text-white/50 mt-1">Consumatori occasionali</div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
